import { tenantStorageKey } from './tenant';

// Raw options (session token, andorUUID) identify the user towards one
// tenant, so they are stored per tenant.
export function getRawOption(key: string, fallback = ''): string {
  try {
    return localStorage.getItem(tenantStorageKey(key)) || fallback;
  } catch {
    return fallback;
  }
}

export function setRawOption(key: string, value: string) {
  try {
    localStorage.setItem(tenantStorageKey(key), value);
  } catch {}
}
